import { render, staticRenderFns } from "./MigrationsValidation.vue?vue&type=template&id=ff6d0e0a"
import script from "./MigrationsValidation.vue?vue&type=script&lang=js"
export * from "./MigrationsValidation.vue?vue&type=script&lang=js"
import style0 from "./MigrationsValidation.vue?vue&type=style&index=0&id=ff6d0e0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports